import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import APIList from '../../../../http/ApiList';

import { Card } from 'antd';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const NewsContainer: React.FC<any> = (props) => {
  const { authInfo, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const [news, setNews] = useState<any>([
    { title: '', text: '' },
    { title: '', text: '' },
  ]);

  const getChatData = (event: any) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        setNews(res.data);
      });
  };

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      property.dataSource &&
      property.dataSource.triggerEvent &&
      property.dataSource.triggerEvent.find((triggerEvent) => {
        return triggerEvent.event === globalEvent.eventType;
      })
    ) {
      getChatData(globalEvent);
    }
  }, [globalEvent]);
  useEffect(() => {}, []);

  return (
    <>
      <div className="news-container">
        {news.map((n, index) => {
          return (
            <div className="news-left-area">
              <Card
                type="inner"
                title={news[index].title}
                bordered={false}
                style={{ width: '100%', height: '90%', overflowY: 'auto', fontSize: '1.1rem' }}
              >
                <Markdown rehypePlugins={[rehypeRaw]}>{news[index].text}</Markdown>
              </Card>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default NewsContainer;
